import * as swcHelpers from '@swc/helpers';
import { useIntl } from '@grandvisionhq/state';

const useSubscriptionIntervalOptions = (deliveryIntervals, subscriptionDeliveryIntervalsFallback)=>{
    const { getFormattedLabel  } = useIntl();
    if (!(deliveryIntervals === null || deliveryIntervals === void 0 ? void 0 : deliveryIntervals.length) && !(subscriptionDeliveryIntervalsFallback === null || subscriptionDeliveryIntervalsFallback === void 0 ? void 0 : subscriptionDeliveryIntervalsFallback.length)) {
        return undefined;
    }
    const unformattedDeliveryOptions = (deliveryIntervals === null || deliveryIntervals === void 0 ? void 0 : deliveryIntervals.length) ? deliveryIntervals : subscriptionDeliveryIntervalsFallback || [];
    const deliveryIntervalOptions = unformattedDeliveryOptions.reduce((acc, interval)=>{
        const key = getFormattedLabel('products.subscriptions.deliveryInterval.option', {
            labelData: {
                days: interval
            }
        });
        return swcHelpers.objectSpread({}, acc, {
            [key]: interval
        });
    }, {});
    return deliveryIntervalOptions;
};

export { useSubscriptionIntervalOptions };
//# sourceMappingURL=use-subscription-interval-options.js.map
